<template>
  <div class="radio-group" :style="getStyle.group">
    <div class="radio" v-for="(option, index) in options" :key="index" :style="getStyle.child">
      <input :id="`${grup}-${index}`" :class="{error : validationError}" :name="grup" :value="option.value" :disabled="disabled" type="radio" v-model="picked">
      <label class="subhead" :for="`${grup}-${index}`">{{option.label}}</label>
    </div>
  </div>
</template>

<script>
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib
export default {
  name: 'adx-radio',
  props: {
    options: {
      required: true
    },
    grup: {
      required: true
    },
    value: {
      required: false
    },
    label: {
      required: false
    },
    valueLabel: {
      required: false
    },
    validation: {
      required: false
    },
    error: {
      required: false
    },
    formStyle: {
      required: false,
      default: `inline`
    },
    disabled: {
      required: false,
      default: false
    },
    isInitial: {
      required: false
    }
  },
  data() {
    return {
      initial: true,
      picked: '',
      valid: undefined,
      message: undefined,
      getStyle: (() => {
        if (this.formStyle === `block`) {
          return {
            group: `flex-direction: column;`,
            child: `margin: 8px 0;`
          }
        }
        return {}
      })()
    }
  },
  mounted() {
    if(this.value) this.picked = this.value
    if (!this.validation) {
      this.$emit(`update:isInitial`, false)
    }
  },
  methods: {
    validateInput(value) {
      if (this.validation) {
        const { valid, message } = validate(this.validation, value, this.label || this.grup)
        if(valid) {
          this.$emit(`update:value`, value)
          this.$emit(`update:error`, false)
        } else {
          this.$emit(`update:value`, ``)
          this.$emit(`update:error`, !valid)
        }
        this.valid = valid
        this.message = message
      } else {
         this.$emit(`update:value`, value)
         this.$emit(`update:error`, false)
      }
      this.$emit(`update:isInitial`, false)
    }
  },
  watch: {
    picked() {
      this.validateInput(this.picked)
    }
  },
  computed: {
    validationError: function () {
      if (this.error) return this.error
      return this.valid === undefined ? false : !this.valid
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>